import * as squint_core from 'squint-cljs/core.js';
import * as dom from './cljdoc.client.dom.jsx';
import * as cljdoc_DOT_client_DOT_dom from './cljdoc.client.dom.jsx';
import * as lib from './cljdoc.client.library.jsx';
import * as cljdoc_DOT_client_DOT_library from './cljdoc.client.library.jsx';
var is_namespace_overview = function () {
return squint_core.boolean$(dom.query(".ns-overview-page"));

};
var is_namespace = function () {
return squint_core.boolean$(dom.query(".ns-page"));

};
var is_namespace_offline = function () {
return squint_core.boolean$(dom.query(".ns-offline-page"));

};
var is_project_doc = function () {
return lib.coords_from_current_loc();

};

export { is_namespace_offline, is_project_doc, is_namespace, is_namespace_overview }
